module.exports = __webpack_public_path__ + "img/m7Ship.1d363a8b.png";